export const ERROR_NAME = 'REQUEST TIMEOUT'

export class RequestTimeoutError extends Error {
  constructor(message) {
    super(message || 'Request Timeout Error')
    this.name = ERROR_NAME
  }
}

export default RequestTimeoutError
